export const CREATE_BENEFIT_GROUPS_CACHE_KEY = 'benefitGroups';

export const CHANGE_BENEFICIARY_GROUP_API_TAG = 'changeBeneficiaryGroup';

export const ERROR_RESPONSE_NOT_UNIQUE_NAME = 'benefit_group_name_already_used';
